export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.browser) {
    import("vue-select").then((VueSelect) => {
      import("vue-select/dist/vue-select.css").then((c) => {
        nuxtApp.vueApp.component("vue-select", VueSelect.default);
      });
    });
  }
});
